import React, { useContext } from "react";
import TotalBusinessModelTable from "./TotalBusinessModelTable";
import TableContainer from "../../../components/TableContainer/TableContainer";
import { useParams } from "react-router";
import { FuturesContext } from "../../../contexts/FuturesContext";
import { AtOnceContext } from "../../../contexts/AtOnceContext";
import { TOTAL_BUSINESS_MODEL_HEADERS } from "./TotalBusinessModel.headers";
import { ShipmentHeaderContext } from "../../../contexts/ShipmentHeaderContext";

const TotalBusinessModelContainer = () => {
  const { horizontalHeaders, monthsInFirstTwoSeasons } = useContext(
    ShipmentHeaderContext,
  );
  const { futuresTotals } = useContext(FuturesContext);
  const { atOnceData } = useContext(AtOnceContext);
  const { tab } = useParams<{ tab: string }>();
  const totalFutures = futuresTotals.concat(
    futuresTotals.reduce((acc, curr) => acc + curr, 0),
  );

  const atOnceTotals = atOnceData[atOnceData.length - 1];
  const totals = [totalFutures].concat([atOnceTotals]).reduce((acc, curr) => {
    if (!acc.length) {
      return curr;
    }
    return acc.map((val, i) => val + curr[i]);
  }, []);
  return (
    <TableContainer
      label={`Total ${
        tab == "tb" ? "Product Engine" : tab.toUpperCase()
      } (Futures + At Once)`}
    >
      <TotalBusinessModelTable
        data={[totalFutures, atOnceTotals, totals]}
        tab={tab.toUpperCase()}
        horizontalHeaders={[...horizontalHeaders.MONTHS, "Total"]}
        monthsInFirstTwoSeasons={monthsInFirstTwoSeasons}
        verticalHeaders={TOTAL_BUSINESS_MODEL_HEADERS}
      />
    </TableContainer>
  );
};

export default TotalBusinessModelContainer;
